<script>
import { defineComponent, h, defineAsyncComponent } from 'vue';

const channelViewList = {
  facebook: defineAsyncComponent(() => import('./channels/Facebook.vue')),
  instagram: defineAsyncComponent(() => import('./channels/Instagram.vue')),
  website: defineAsyncComponent(() => import('./channels/Website.vue')),
  twitter: defineAsyncComponent(() => import('./channels/Twitter.vue')),
  api: defineAsyncComponent(() => import('./channels/Api.vue')),
  email: defineAsyncComponent(() => import('./channels/Email.vue')),
  sms: defineAsyncComponent(() => import('./channels/Sms.vue')),
  whatsapp: defineAsyncComponent(() => import('./channels/Whatsapp.vue')),
  line: defineAsyncComponent(() => import('./channels/Line.vue')),
  telegram: defineAsyncComponent(() => import('./channels/Telegram.vue')),
};

export default defineComponent({
  name: 'NewChannelView',
  props: {
    channelName: {
      type: String,
      required: true,
    },
  },
  render() {
    const ChannelComponent = channelViewList[this.channelName];
    return ChannelComponent ? h(ChannelComponent) : null;
  },
});
</script>
